import classnames from "classnames";
import {Link} from "react-router";

import {cropWithEllipsis} from "@/lib/displayUtils.ts";
import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {getCheckDetailUrl} from "@/pages/checks/utils.ts";

type ChecksName = {
  id: number;
  name: string;
  type: MonitoringServiceType;
  address: string;
  textClass?: string;
  maxLength?: number;
  isEmptyGroup?: boolean;
};

export const CheckName = ({id, name, type, address, maxLength, textClass, isEmptyGroup}: ChecksName) => {
  const checkLink = getCheckDetailUrl(id, type, isEmptyGroup);
  return (
    <>
      <Link to={checkLink} className={classnames("d-block", textClass || "text-dark")}>
        {cropWithEllipsis(name, maxLength)}
      </Link>
      <Link to={checkLink} title={address} className={"pulse-color-gray-600"}>
        {cropWithEllipsis(address, maxLength)}
      </Link>
    </>
  );
};
